<template>
  <div class="owners-data-wrapper">

    <div class="owner-details-percent-wrapper">
      <div class="ownerItem fluid">
        <div class="-helper--flex align-center space-between">
          <h4>Owner #1</h4>
          <div class="-helper--flex align-center">
          </div>
        </div>
        <p id="elPOwnerFullName">{{customerData.firstName}} {{customerData.lastName}}</p>
      </div>

      <div class="percent-controller-wrapper fluid">
        <v-text-field
          dense
          filled
          rounded
          validate-on-blur
          autocomplete="null"
          v-model="pSlider"
          @blur="handleRawPercentBlur"
          v-on:focus="updatePercentState('text')"
          v-on:change="checkForAllowedOwners()"
          inputmode="numeric"
          v-mask="'###'"
          id="percentOwned"
          suffix="%"
          class="percent"
          hide-details
        >
        </v-text-field>
        <div style="display: flex; flex-direction: column; gap: 16px" class="fluid">
          <p class="ownership-slider-title">Ownership Percentage </p>
          <input class="percentSlider" type="range" min="0" max="100" v-model="pSlider" step="1" id="myRange" v-on:focus="updatePercentState('slider')" v-on:change="checkForAllowedOwners()">
        </div>
      </div>
    </div>

    <div class="additional-owners-control-wrapper">
      <div :id="`ownerDetails_${idx}`" class="ownerItem relative -helper--flex column" v-for="(owner,idx) in customerData.businessOwners" :key="owner.firstName + JSON.stringify(idx)">
        <div class="-helper--flex align-center space-between">
          <h4>Owner #{{idx+2}}</h4>
          <div class="-helper--flex align-center">
            <img v-if="shouldAllowEdit(owner)" id="addUbo" @click="handleAddOwner(owner.externalId)" style="margin-right: 10px; cursor: pointer" width="14px" src="../../../RF_assets/icons/edit-gray-v2.svg" />
            <img id="removeUbo" @click="handleDeleteOwner(owner.externalId, idx)" style="cursor: pointer" width="14px" src="../../../RF_assets/icons/trashcan-gray.svg" />
          </div>
        </div>
        <p>{{owner.firstName}} {{owner.lastName}}<span style="margin-left: 12px">{{owner.ownershipPercent ? `(${owner.ownershipPercent}%)` : ''}}</span></p>
      </div>
    </div>

    <div class="add-another-owner-wrapper">



    <button v-if="isAllowAddOwner" @click="handleAddOwner" class="add-owner-cta">+ Add another owner</button>
      <BtnCheckbox
        v-if="!this.customerData.businessOwners.length"
        v-model="flags.isOnlyUbo"
        id="only-ubo"
        txt="I am the only UBO"
        class="only-ubo"
      />
    </div>
    <v-checkbox
     v-if="this.customerData.businessOwners.length"
      v-model="flags.isChecked"
      :rules="rules.checkbox"
      label=""
      color="#0078A7"
      value="#0078A7"
      id="owner-decleration"
      class="owner-decleration"
    >
      <template v-slot:label>
        <p class="check-disclaimer">
          I hereby certify that the beneficial owner list contains all owners of
          the business who own <br />
          <b> 25% or more </b> interest
        </p>
      </template>
    </v-checkbox>
  </div>
</template>

<script>
import {params} from '../../../localData'
import BtnCheckbox from '../../../components/globalUiComponents/btn/BtnCheckbox'
import {getMaxUboPercentLeft} from '../../../services/UtilService'

export default {
  name: 'BusinessOwners',
  components: {
    BtnCheckbox
  },
  watch: {
    pSlider (rangeValue) {
      const min = 0
      const max = 100
      let percentToSetOnState = 0
      const rangeSlider = document.getElementById('myRange')
      const value = (rangeValue - min) / (max - min) * 100
      rangeSlider.style.setProperty('--value', `${value}%`)

      if (rangeValue < min) {
        percentToSetOnState = min
      } else if (rangeValue > max) {
        percentToSetOnState = max
      } else {
        percentToSetOnState = rangeValue
      }
      this.$store.commit('customer/setKeyValue', {prop: 'ownershipPercent', value: percentToSetOnState})
    }
  },
  async mounted () {
    this.pSlider = this.customerData.ownershipPercent
    const rangeSlider = document.getElementById('myRange')
    const value = this.customerData.ownershipPercent
    rangeSlider.style.setProperty('--value', `${value}%`)

    if (this.customerData.businessId) {
      await this.fetchUbos()
    }
  },
  computed: {
    customerData () {
      return this.$store.getters['customer/data']
    },
    isAllowAddOwner () {
      return getMaxUboPercentLeft(this.customerData) >= 25
    },
    ajaxDataBusinessDetails () {
      return {
        method: 'post',
        endPoint:
          params.restEndpoints.address + this.customerData.customerId + '/business',
        data: {
          segment: this.customerData.segment,
          naicsIndustry: this.customerData.sub_industry,
          mainIncomeSource: this.customerData.incomeType.enum || null,
          businessName: this.customerData.businessName || null,
          incorporationState: this.customerData.businessRegisteredState || null,
          ein: (this.customerData.ein && this.customerData.ein.replace('-', '')) || null
        },
        self: this
      }
    },
    ajaxData () {
      return {
        method: 'get',
        endPoint: `v3/secureonboarding/partner/user/${this.customerData.customerId}/business/${this.customerData.businessId}/ubo`,
        data: {},
        self: this
      }
    },
    ownerShipAjaxData () {
      return {
        method: 'post',
        endPoint: `v3/secureonboarding/partner/user/${this.customerData.customerId}/business/${this.customerData.businessId}/ownershipPercent`,
        data: {
          ownershipPercent: this.customerData.ownershipPercent
        },
        self: this
      }
    },
    deleteUboAjaxData () {
      return {
        method: 'delete',
        endPoint: `v3/secureonboarding/partner/user/${this.customerData.customerId}/business/${this.customerData.businessId}/ubo/${this.ownerToDelete}`,
        data: {},
        self: this
      }
    }
  },
  methods: {
    async handleDeleteOwner (ownerId, idx) {
      this.ownerToDelete = ownerId
      this.flags.isLoading = true
      try {
        await this.$store.dispatch(
          'customer/updateCustomer',
          {
            ...this.deleteUboAjaxData,
            header: {
              headerName: params.httpHeaders.auth,
              headerValue: 'lili ' + this.customerData.accessToken
            }
          },
          this
        )
        this.ownerToDelete = ''
        // Update on state
        const ownersList = [...this.customerData.businessOwners]
        ownersList.splice(idx, 1)
        this.$store.commit('customer/setKeyValue', {prop: 'businessOwners', value: ownersList})
        this.flags.isLoading = true
      } catch (e) {
        this.flags.isLoading = false
        console.log(e)
      }
    },
    handleEditUbo (ownerId) {
      this.$router.push(`/partner/add-owner?editRef=${ownerId}`)
    },
    async fetchUbos () {
      try {
        const res = await this.$store.dispatch(
          'customer/updateCustomer',
          {
            ...this.ajaxData,
            header: {
              headerName: params.httpHeaders.auth,
              headerValue: 'lili ' + this.customerData.accessToken
            }
          },
          this
        )
        const ownersList = res.uboResponseList
        this.$store.commit('customer/setKeyValue', {prop: 'businessOwners', value: ownersList})
      } catch (e) {
        console.log(e)
      }
    },
    handleCheck () {
      // @TODO check if no owners (Im only the ubo) should we set ownership to 100%
      this.flags.isChecked = !this.flags.isChecked
    },
    shouldAllowEdit (owner) {
      return !!('allowEditing' in owner && owner.allowEditing)
    },
    async initOwnershipPercent () {
      await this.$store.dispatch(
        'customer/updateCustomer',
        {
          ...this.ownerShipAjaxData,
          header: {
            headerName: params.httpHeaders.auth,
            headerValue: 'lili ' + this.customerData.accessToken
          }
        },
        this
      )
    },
    async handleBusinessDetails () {
      try {
        const res = await this.$store.dispatch(
          'customer/updateCustomer',
          {
            ...this.ajaxDataBusinessDetails,
            header: {
              headerName: params.httpHeaders.auth,
              headerValue: 'lili ' + this.customerData.accessToken
            }
          },
          this
        )
        this.$store.commit('customer/setKeyValue', {prop: 'businessId', value: res.externalId})
        if ('primaryOwnershipPercent' in res) {
          this.$store.commit('customer/setKeyValue', {prop: 'ownershipPercent', value: res.primaryOwnershipPercent})
        }
        window.hj('identify', {businessType: this.customerData.segment})
        // Move to add owner
        this.$router.push({name: 'addOwner'})
      } catch (e) {
        document.querySelector('.partner-business-view').scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        })
        console.log(e)
        // Handle error related handleBusinessDetails
        throw e
      }
    },
    async handleAddOwner (ownerId) {
      if (!this.customerData.businessId) {
        await this.handleBusinessDetails()
        await this.initOwnershipPercent()
      } else {
        await this.initOwnershipPercent()
        if (ownerId) {
          this.handleEditUbo(ownerId)
        } else {
          this.$router.push({name: 'addOwner'})
        }
      }
    },
    handleRawPercentBlur () {
      if (this.pSlider < 0) {
        this.pSlider = 0
      } else if (this.pSlider > 100) {
        this.pSlider = 100
      }
    },
    checkForAllowedOwners () {
      if (this.isAllowAddOwner) {
        this.flags.isAddOwnerError = false
      }
    },
    clearFieldError (field) {
      this.$store.dispatch('errors/clearSpecificFieldError', [field])
    },
    updatePercentState (controlType) {
      this.clearFieldError('percentOwned')
      if (controlType === 'text') {
        this.$store.commit('onboarding/setKeyValue', {
          prop: 'isOwnershipPercentTextboxTouched',
          value: true
        })
      } else if (controlType === 'slider') {
        this.$store.commit('onboarding/setKeyValue', {
          prop: 'isOwnershipPercentSliderTouched',
          value: true
        })
      }
    }
  },
  data () {
    return {
      ownerToDelete: {},
      pSlider: 50,
      flags: {
        isAddOwnerError: true,
        isChecked: false,
        isLoading: false,
        isOnlyUbo: false
      },
      rules: {
        checkbox: [v => !!v || '']
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.owners-data-wrapper {
  display: flex;
  flex-direction: column;
}
.owner-details-percent-wrapper {
  display: flex;
  align-items: start;
  gap: 28px;
  padding-bottom: 32px;
  margin-bottom: 32px;
  border-bottom: 1px solid #DFE2EB;
}
.ownerItem {
  padding: 6px 16px;
  background-color: white;
  width: 100%;
  border-radius: 6px;
  border: 1px solid #DFE2EB;
  max-width: 327px;
}
.ownerItem h4 {
  color: #868686;
  font-family: MetricRRegular;
  font-size: 14px;
  margin-bottom: 6px;
  font-weight: lighter;
  font-style: normal;
}
.ownerItem p {
  font-family: MetricRMedium;
  font-size: 14px;
  color: #161919;
  font-style: normal;
}
.percent-controller-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
}

.ownership-slider-title {
  font-family: MetricRRegular;
  font-size: 12px;
  color: #525D71;
}

.additional-owners-control-wrapper {
  display: flex;
  align-items: center;
  gap: 28px;
  flex-wrap: wrap;
}


.add-another-owner-wrapper {
  display: flex;
  margin-top: 32px;
  gap: 22px;
   >* {
    flex-grow: 1;
   }
}

.only-ubo,
.add-owner-cta{
  padding: 18px 8px;
  border: 1px solid #DFE2EB;
  border-radius: 6px;
  background-color: white;
  font-family: MetricRMedium;
  font-size: 14px;
}
.only-ubo {
  color: #525D71;
}
.add-owner-cta {
  color: #0078A7;
  &:hover {
    background-color: rgb(251, 253, 255);
  }
}

.percent {

    max-width: 80px;
}
/* Change the background color of the entire range slider */
.percentSlider {
  -webkit-appearance: none;
  width: 100%;
  height: 5px;
  border-radius: 8px;
  background: #C4CBDC; /* Gray background */
  outline: none;
  opacity: 0.7;
  -webkit-transition: .2s;
  transition: opacity .2s;
}

/* Change the color of the filled part of the range slider track */
.percentSlider::-webkit-slider-runnable-track {
  background: linear-gradient(to right, #0078A7 var(--value, 0%), #C4CBDC var(--value, 0%));
  height: 5px;
  border-radius: 8px;
}

.percentSlider::-moz-range-track {
  background: linear-gradient(to right, #0078A7 var(--value, 0%), #C4CBDC var(--value, 0%));
  height: 5px;
  border-radius: 8px;
}

/* Change the color of the thumb */
.percentSlider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 26px;
  height: 26px;
  background-image: url("~@/RF_assets/icons/thumb-img.svg");
  background-position: center;
  background-repeat: no-repeat;
  margin-top: -10px;
  cursor: pointer;
}

.percentSlider::-moz-range-thumb {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  border: 1px solid #0078A7;
  background: #ffffff;
  cursor: pointer;
  margin-top: -10px;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}
@media only screen and (max-width: 480px) {
  .owner-details-percent-wrapper {
    flex-direction: column;
    border-bottom: unset;
    padding-bottom: 0;
    margin-bottom: 0;
    gap: 24px;
  }
  .additional-owners-control-wrapper {
    gap: 16px;
  }
  .owner-decleration {
    height: 73px;
  }
  .ownerItem {
    margin-top: 16px;
    max-width: unset;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/PartnerOnboarding/business-sections/BusinessOwners.vue